import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import diamond from '@sorare/core/src/assets/animations/diamond.png';
import { fantasy } from '@sorare/core/src/lib/glossary';
import { withFragments } from '@sorare/core/src/lib/gql';

import { RuleHelperFnReturnType } from 'components/so5/Rules/types';

import { getSumOfAverageScoresRule_so5Rules } from './__generated__/getSumOfAverageScoresRule.graphql';

export const getSumOfAverageScoresRule = withFragments(
  (
    rules: getSumOfAverageScoresRule_so5Rules,
    error: string
  ): RuleHelperFnReturnType => {
    const rule = rules.sumOfAverageScores;
    if (!rule) {
      return null;
    }
    return {
      id: 'sumOfAverageScores',
      label: (
        <FormattedMessage {...fantasy.pointsCap} values={{ value: rule }} />
      ),
      description: (
        <FormattedMessage
          id="Rules.sumOfAverageScores.description"
          defaultMessage="Sum of players' average score must remain below {value}"
          values={{ value: rule }}
        />
      ),
      icon: <img src={diamond} alt="" width="16" height="16" />,
      error,
    };
  },
  {
    so5Rules: gql`
      fragment getSumOfAverageScoresRule_so5Rules on So5Rules {
        id
        sumOfAverageScores
      }
    ` as TypedDocumentNode<getSumOfAverageScoresRule_so5Rules>,
  }
);
